// useCreateTicket hook

import { WpGenericPost, WpTicketMetaBox } from "@hooks/use-get/tickets/types";
import { useUpdateTicket } from "@hooks/use-update/ticket";

export const useCreateTicket = () => {
    const { updateTicket, loading, error } = useUpdateTicket();
    const createTicket = async (
        ticketValue: Partial<WpGenericPost<WpTicketMetaBox>>
    ) => {
        return await updateTicket("", { ...ticketValue, status: "publish" });
    };

    return {
        createTicket,
        loading,
        error,
    };
};
